import Validators from '../validators'
import * as defaultConst from '../../../constants/default_constants'
import Moment from 'moment'
import { extendMoment } from 'moment-range'
const moment = extendMoment(Moment)

export default (store) => store.createEmbededEntityState({
  lastSave: 'uploads',
  timeRestriction: 'uploads',
  attrs: [
    'id', 'file_type', 'parent_id', 'subtitles', 'state', 'validity', 'preview', 'regions',
    'lang', 'final_length', 'original_filename', 's3_filename', 'valid_from', 'valid_to'
  ],
  noSort: ['preview', 'validity', 'subtitles'],
  titles: [
    store.__('ID'), store.__('file type'), store.__('parent'), store.__('subtitles'),
    store.__('state'), store.__('validity'), store.__('preview'),
    store.__('regions'), store.__('language'), store.__('original size'), store.__('original filename'), store.__('S3 filename'),
    store.__('valid from'), store.__('valid to')
  ],
  initVals: (row) => {
    return {
      video_id: store.cv.record.get('id'),
      lang: 'en',
      valid_from: Moment().format(defaultConst.DATE_FORMAT),
      valid_to: defaultConst.DATE_MAX_DATE
    }
  },
  _sortField: 'file_type,regions,valid_from,valid_to',
  _sortDir: 'ASC,ASC,ASC,ASC',
  validators: {
    file_type: Validators.isMandatory(store),
    regions: [
      Validators.isMandatory(store),
      Validators.regionTest(store)
    ],
    lang: Validators.isMandatory(store),
    valid_from: [
      Validators.isMandatoryDate(store),
      Validators.isValidFromTo(store)
    ],
    valid_to: [
      Validators.isMandatoryDate(store),
      Validators.isValidFromTo(store)
    ],
    _global: (vals) => {
      const file = vals.get('file')
      const fileType = vals.has('file_type') && vals.get('file_type')
      const fileWidth = vals.has('file_width') && vals.get('file_width')
      const fileHeight = vals.has('file_height') && vals.get('file_height')
      const toRound = (num) => Math.round(num * 100) / 100
      const errors = store.cv.subentities.uploads.errors
      const items = store.cv.uploads

      // for subtitles only
      const typeSubtitles = vals.has('file_type') && vals.get('file_type') && defaultConst.SUBTITLES_TYPES.indexOf(vals.get('file_type')) >= 0
      const parentItem = vals.has('parent_id') && vals.get('parent_id') && items.find(i => i.id === vals.get('parent_id'))
      const countries = store.options.get('Countries')

      if (typeSubtitles && (!vals.has('parent_id') || !vals.get('parent_id'))) {
        errors.set('parent_id', store.__('This is mandatory'))
      } else {
        errors.delete('parent_id')
      }
      if (typeSubtitles && parentItem && moment(vals.get('valid_from')).isBefore(moment(parentItem.valid_from), 'day')) {
        errors.set('valid_from', store.__('This date is out of range of the parent'))
      } else {
        errors.delete('valid_from')
      }
      if (typeSubtitles && parentItem && moment(vals.get('valid_to')).isAfter(moment(parentItem.valid_to), 'day')) {
        errors.set('valid_to', store.__('This date is out of range of the parent'))
      } else {
        errors.delete('valid_to')
      }
      if (typeSubtitles && parentItem && vals.has('parent_id') && vals.get('parent_id')) {
        const parentFilename = parentItem.s3_filename.indexOf('/') >= 0
          ? parentItem.s3_filename.substr(0, parentItem.s3_filename.indexOf('/'))
          : parentItem.s3_filename
        vals.set('parent_s3_filename', parentFilename)
        vals.set('parent_file_type', parentItem.file_type)
        if (moment(vals.get('valid_to')).isAfter(moment(parentItem.valid_to), 'day')) {
          vals.set('valid_to', parentItem.valid_to)
        }
      } else {
        vals.delete('parent_s3_filename')
        vals.delete('parent_file_type')
      }

      if (typeSubtitles && parentItem && parentItem.regions !== 'WW' && parentItem.regions !== '' && vals.has('regions') && vals.get('regions')) {
        const getRegions = (regions) => {
          const splitRegions = (regions.charAt(0) === '-' ? regions.substring(1) : regions).split(',')
          return regions.charAt(0) === '-'
            ? countries.map(country => !splitRegions
              .find(region => region === country.value) && country.value)
              .filter(result => result && result.length <= 2)
            : splitRegions
        }
        const itemRegions = getRegions(vals.get('regions'))
        const compareRegions = getRegions(parentItem.regions).filter(r => itemRegions.includes(r))

        if (itemRegions.length > compareRegions.length) {
          errors.set('regions', store.__('This regions are out of range of the parent'))
        } else {
          errors.delete('regions')
        }
      }

      // new item, file is mandatory
      if (!file && !vals.has('id') && !vals.has('loadedfromcopy')) {
        return store.__('This is mandatory')
      }

      if (fileType && file) {
        errors.delete('file')
        // file type errors
        if (defaultConst.VIDEO_TYPES.indexOf(fileType) >= 0 && file.type !== 'video/mp4') {
          return store.__('This is not valid video/mp4 file')
        }
        if (defaultConst.VIDEO_TYPES.indexOf(fileType) < 0 &&
            defaultConst.SUBTITLES_TYPES.indexOf(fileType) < 0 &&
            file.type !== 'image/jpeg') {
          return store.__('This is not valid image/jpeg file')
        }

        // subtitles
        if (defaultConst.SUBTITLES_TYPES.indexOf(fileType) >= 0) {
          const subP = defaultConst.UPLOAD_SUBTITLES_POSTFIX
          const subT = defaultConst.UPLOAD_SUBTITLES_TEST_STRING

          if (file.name.toLowerCase().indexOf(subP) < 0 || (file.type && file.type.toLowerCase().indexOf(subP) < 0)) {
            errors.set('file', store.__('This is not a valid file type: .') + subP)
            console.log('Error - file.name:', file.name)
            console.log('Error - file.type:', file.type)
          }
          if (typeof window.FileReader !== 'undefined') {
            // subtitles content test
            const reader = new FileReader()
            reader.readAsText(file)
            reader.onload = function () {
              if (!reader.result || reader.result.substring(0, subT.length).toLowerCase() !== subT.toLowerCase()) {
                errors.set('file', store.__('This is not a valid file type: .') + subP)
              }
            }
            reader.onerror = function () {
              console.log('Error - test string:', subT)
              console.log('Error - reader.result content:', reader.result)
            }
          }
        }

        // ratio and resolution checking
        if (fileType && file.type === 'image/jpeg' && fileWidth && fileHeight && fileType && defaultConst.IMAGE_RESOLUTIONS[fileType]) {
          const imgResolution = toRound(parseFloat(fileWidth) / parseFloat(fileHeight))
          const allowedWidth = parseFloat(defaultConst.IMAGE_RESOLUTIONS[fileType][0])
          const allowedHeight = parseFloat(defaultConst.IMAGE_RESOLUTIONS[fileType][1])
          const allowedResolution = toRound(allowedWidth / allowedHeight)
          if (imgResolution !== allowedResolution) {
            return store.__('This is not valid') + ' "' +
              store.options.get('UploadTypes').find((i) => i.value === fileType).text +
              '" ' + store.__('image ratio') +
              `: ${allowedWidth}/${allowedHeight} – ` +
              store.__('The resolution of your image is') +
              `: ${fileWidth}px/${fileHeight}px.`
          }
        }
      }
      const validFrom = new Date(vals.get('valid_from'))
      const validTo = new Date(vals.get('valid_to'))
      if (validFrom && validTo && validFrom > validTo) {
        return [store.__('Valid from be less than valid to, bro')]
      }
      // validate distictive intervals of other record with same file_type
      const isOverlapping = (cStart, cEnd, nStart, nEnd) => {
        const cRange = cStart && cEnd && moment.range(cStart, cEnd)
        const nRange = nStart && nEnd && moment.range(nStart, nEnd)
        return cRange.overlaps(nRange) || nRange.overlaps(cRange) ||
          moment(cStart).format('YYYY-MM-DD') === moment(nEnd).format('YYYY-MM-DD') ||
          moment(nStart).format('YYYY-MM-DD') === moment(cEnd).format('YYYY-MM-DD')
      }
      const overlapping = store.cv.uploads.filter((i) => {
        const skip = (vals.has('id') && (vals.get('id') === i.id)) ||
          vals.get('file_type') !== i.file_type ||
          vals.get('lang') !== i.lang ||
          vals.get('regions') !== i.regions
        if (skip) {
          return
        }
        if (isOverlapping(validFrom, validTo, new Date(i.valid_from), new Date(i.valid_to))) {
          return i
        }
      })
      if (overlapping.length > 0) {
        return overlapping.map((item) => {
          return `${store.__('Selected interval \'valid from/to\' overlaps with another')}
            '${item.file_type}' ${store.__('with language')} '${item.lang}' ${store.__('and region')} '${item.regions}'`
        })
      }
    }
  }
})
